let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2CL1b")).then(() => parcelRequire('4G8MP'));